import {Outlet} from "react-router-dom";
import {Fragment, useContext} from "react";
import {ReactComponent as CrownLogo} from "../../../../src/assets/crown.svg";
import './navigation.styles'
import { UserContext } from "../../../contexts/user.context";
import { CartContext } from "../../../contexts/cart.context";
import { signOutUser } from '../../../utils/firebase/firebase.utils';
import CartIcon from "../../cart-icon/cart-icon.component";
import CartDropdown from "../../cart-dropdown/cart-dropdown.component";

import {LogoContainer, NavigationContainer, NavLinks, NavLink} from "./navigation.styles";

const Navigation = () => {

    const { currentUser} = useContext(UserContext);
    // console.log(JSON.stringify(currentUser, null, 2));

    const { isCartOpen} = useContext(CartContext)

    return (
        <Fragment>
            <NavigationContainer>
                <LogoContainer to='/'>
                    <CrownLogo className="logo"/>
                </LogoContainer>
                <NavLinks>
                    <NavLink to="/shop">SHOP</NavLink>
                    {
                        currentUser ? (
                            <NavLink as="span" onClick={signOutUser}>Sign Out</NavLink>

                        ) : (
                            <NavLink to="/auth">Sign In</NavLink>
                        )
                    }
                    <CartIcon />
                </NavLinks>
                {isCartOpen && <CartDropdown />}

            </NavigationContainer>
            <Outlet/>
        </Fragment>
    )
}

export default Navigation
